export function hasCallRecording(activity) {
  return Boolean(activity?.recording_file)
}
